import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className"];
import React from 'react';
import classNames from 'classnames';
import { useDeprecatedClassNameStylePropsWarning } from '../../internal/deprecated-classname-style-props';
import styles from './List.module.less'; // <List spacing={...} /> uses this to pass the value of its
// spacing prop down to these disconnected <Li /> components

export var ListSpacingContext = /*#__PURE__*/React.createContext(2); // nested lists add spacing above first <Li /> component

var ListIsNestedContext = /*#__PURE__*/React.createContext(false);
// TODO: in currency v2, we should rename this to ListItem, or (preferably)
// automatically wrap each list child as an item.
export var Li = /*#__PURE__*/React.forwardRef(function (props, ref) {
  useDeprecatedClassNameStylePropsWarning('Li', {
    className: props.className
  });

  var children = props.children,
      className = props.className,
      otherProps = _objectWithoutProperties(props, _excluded);

  var inNestedList = React.useContext(ListIsNestedContext);
  var spacing = React.useContext(ListSpacingContext);
  return /*#__PURE__*/React.createElement("li", _extends({
    className: classNames(className, styles['list-item'], styles["list-item-spacing-".concat(spacing)], !inNestedList && styles['list-item-not-nested'])
  }, otherProps, {
    ref: ref
  }), /*#__PURE__*/React.createElement(ListIsNestedContext.Provider, {
    value: true
  }, children));
});
Li.displayName = 'Li';